import React, { useState, createContext } from 'react'
import { MODAL_FIELD_INFO } from '../constants/display'

export const ModalContext = createContext({
  fieldInfo: 'CURRENT_MONTHLY_HOME_COSTS',
})

export const ModalContextProvider = ({ children }) => {
  const [showInfoModal, setShowInfoModal] = useState(false)
  const [fieldInfo, setFieldInfo] = useState(
    MODAL_FIELD_INFO.CURRENT_MONTHLY_HOME_COSTS
  )

  const value = {
    showInfoModal,
    setShowInfoModal,
    fieldInfo,
    setFieldInfo,
  }

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
}
